module.exports = __webpack_public_path__ + "img/Screenshot-4.0f8219c1.png";